<div class="cursor-default fixed inset-0 w-screen h-screen overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 z-[100] text-base">
    <div class="flex items-center justify-center pt-20">
        <div #confirmationModal class="w-[400px] h-[225px] bg-slate-100 rounded shadow-lg flex flex-col">
            <div class="p-2 flex flex-row bg-ponder-light text-slate-50 font-bold rounded-t shadow">
                <div class="grow">
                    {{ title }}
                </div>
                <div (click)="onCloseClicked()" class="stroke-faded-50 hover:stroke-white hover:cursor-pointer">
                    <svg class="pl-1 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                        <title>Close</title>
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                    </svg>
                </div>
            </div>
            <div class="p-2 flex flex-col gap-2 grow overflow-y-auto" [ngClass]="{ 'justify-center text-center' : centered }">
                <div>
                    {{ body }}
                </div>
                <div class="font-bold">
                    {{ serious }}
                </div>
            </div>
            <div class="p-2 flex flex-row gap-4 items-center align-middle justify-end">
                <button (click)="onCloseClicked()" class="p-2 w-20 bg-slate-50 hover:bg-white rounded-sm shadow">
                    Cancel
                </button>
                <button (click)="onConfirmClicked()" class="p-2 w-20 text-slate-50 bg-red-700 hover:bg-red-500 rounded-sm shadow">
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>